import { applyMiddleware, compose, combineReducers, Middleware, Store, createStore as reduxCreateStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import loginReducer from './login/reducer';
import msalReducer from './msal/reducer';
import profileReducer from './profile/reducer';
import forgotPasswordReducer from './forgot-password/reducer';
import resetPasswordReducer from './reset-password/reducer';
import userEmailConfirmationReducer from './user-email-confirmation/reducer';
import verifyCompanyReducer from './verify-company/reducer';
import companyReducer from './company/reducer';
import clientReducer from './client/reducer';
import userReducer from './user/reducer';
import portfolioReducer from './portfolio/reducer';
import exportReducer from './export/reducer';
import settingsReducer from './settings/reducer';
import draftReducer from './draft/reducer';
import transactionCompsReducer from './transactioncomps/reducer';

import {
  accountingTypesReducer,
  companyReportingTypesReducer,
  companyTransactionTypesReducer,
  currenciesReducer,
  dataSiteHostsReducer,
  dataSiteProvidersReducer,
  dataSiteStatusReducer,
  dataSiteTypesReducer,
  debtIssuanceTypesReducer,
  industriesReducer,
  industryGroupsReducer,
  fitchIndustriesReducer,
  newsFiltersReducer,
  sectorsReducer,
  subscriptionsReducer,
  userTitlesReducer,
} from './staticData';
import searchReducer from './search/reducer';
import newsAdminReducer from './news/admin/reducers';
import releaseFeatureFlagsReducer from './release-feature-flags/reducer';
import cloReducer from './clo/reducer';
import cloDealReducer from '$/store/cloDeal/reducer';
import cloDealManagerReducer from '$/store/cloDealManager/reducer';
import cloDealHoldingFOrBixbyIdMappingReducer from '$/store/cloDealHoldingBixybyIdMapping/reducer';
import cloDealBixbyIdMappingReducer from '$/store/cloDealBixybyIdMapping/reducer';

const rootReducer = combineReducers({
  accountingTypeState: accountingTypesReducer,
  clientState: clientReducer,
  companyReportingTypeState: companyReportingTypesReducer,
  companyTransactionTypeState: companyTransactionTypesReducer,
  companyState: companyReducer,
  cloState: cloReducer,
  cloDealState: cloDealReducer,
  cloDealManagerState: cloDealManagerReducer,
  cloDealHoldingBixbyIdMappingState: cloDealHoldingFOrBixbyIdMappingReducer,
  cloDealBixIdMappingState: cloDealBixbyIdMappingReducer,
  currenciesState: currenciesReducer,
  dataSiteHostState: dataSiteHostsReducer,
  dataSiteProviderState: dataSiteProvidersReducer,
  dataSiteStatusState: dataSiteStatusReducer,
  dataSiteTypeState: dataSiteTypesReducer,
  debtIssuanceTypeState: debtIssuanceTypesReducer,
  draftState: draftReducer,
  exportState: exportReducer,
  forgotPasswordState: forgotPasswordReducer,
  industryState: industriesReducer,
  industryGroupState: industryGroupsReducer,
  fitchIndustryState: fitchIndustriesReducer,
  loginState: loginReducer,
  msalState: msalReducer,
  newsFiltersState: newsFiltersReducer,
  newsAdminState: newsAdminReducer,
  portfolioState: portfolioReducer,
  profileState: profileReducer,
  releaseFeatureFlagsState: releaseFeatureFlagsReducer,
  resetPasswordState: resetPasswordReducer,
  searchState: searchReducer,
  sectorState: sectorsReducer,
  settingsState: settingsReducer,
  subscriptionState: subscriptionsReducer,
  transactionCompsState: transactionCompsReducer,
  userEmailConfirmationState: userEmailConfirmationReducer,
  userState: userReducer,
  userTitleState: userTitlesReducer,
  verifyCompanyState: verifyCompanyReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export const createStore = (preloadedState?: Partial<AppState>): Store<AppState> => {
  const middlewares: Middleware[] = [thunkMiddleware];

  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return reduxCreateStore(rootReducer, preloadedState || {}, composeEnhancers(applyMiddleware(...middlewares)));
};

export const store = createStore();
